import AccountButton from "components/AccountButton";
import { useContext } from "react";
import { AiOutlineMenu } from "react-icons/ai";
// import { BsBell, BsEnvelopeOpen } from "react-icons/bs";
import { DashboardContext } from "./DashboardContext";
import NotificationBell from "./Header/NotificationBell";

const DashboardHeader = () => {
  const context = useContext(DashboardContext);

  const { handleHeaderToggle } = context;
  return (
    <div className="flex flex-col lg:shadow-lg  md:flex-row  justify-between h-fit md:h-[70px] md:items-center bg-header/70 md:px-8 shadow-2xl ">
      <div className="flex items-center shadow-md md:shadow-none py-5 px-5  space-x-5">
        <button
          onClick={() => {
            handleHeaderToggle();
          }}
        >
          <AiOutlineMenu className="w-8 h-8   hover:text-primary transition-all duration-300 ease-out active:scale-75" />
        </button>
        <span>Dashboard</span>
      </div>
      <div className="flex items-center shadow-lg md:shadow-none z-10 w-full lg:justify-end justify-between space-x-5 px-8 py-1">
        <div className=" flex items-center space-x-7">
          <NotificationBell />
          {/* <BsEnvelopeOpen className="w-5 h-5" /> */}
        </div>

        <AccountButton />
      </div>
    </div>
  );
};

export default DashboardHeader;
